export class Success<T> {
  public data?: T;
  public message?: string;
}
